// extracted by mini-css-extract-plugin
module.exports = {"container":"Player_container__1DFKZ","icon":"Player_icon__2fdEC","tooltip":"Player_tooltip__3-Kys","tooltip-arrow":"Player_tooltip-arrow__od8l1"};